import './nu-opt-slideshow.js';
import './nu-opt-accordion-custom.js';
import './nu-opt-video-background.js';
import './nu-opt-media.js';
import './nu-opt-rte-formatter.js';

function mountFrenzy(root) {
  const placements = [...root.querySelectorAll('.nu-optional-section [data-frenzy-deferred], .nu-optional-section .frenzy_landing_page_carousel_section')];
  if (!placements.length) return;
  for (const el of placements) {
    if (el.dataset.frenzyDeferred) {
      el.classList.add(el.dataset.frenzyDeferred);
      delete el.dataset.frenzyDeferred;
    }
  }
  const wasReady = window.nuudsFrenzyReady;
  // The current theme owns the SDK, product cards, swatches, and cart integration.
  Promise.resolve(window.nuudsStartFrenzy?.()).then(() => {
    if (wasReady && typeof window.renderRecommendations === 'function') window.renderRecommendations();
    document.dispatchEvent(new CustomEvent('nuuds:frenzy-carousels-mounted'));
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountFrenzy(document), { once: true });
else mountFrenzy(document);
document.addEventListener('shopify:section:load', () => mountFrenzy(document));
document.addEventListener('shopify:block:select', (event) => {
  const slide = event.target.closest('slideshow-slide');
  const slideshow = slide?.closest('slideshow-component');
  if (slideshow && slide.closest('.nu-optional-section')) {
    slideshow.pause?.();
    slideshow.select?.({ id: slide.getAttribute('slide-id') }, undefined, { animate: false });
  }
});
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.nu-optional-section [data-klaviyo-form-id]');
  if (!trigger) return;
  event.preventDefault();
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', trigger.dataset.klaviyoFormId]);
});
